import React from 'react';
import SmartDialog from "../../components/SmartDialog";
import LoadingView from "../../components/Elements/LoadingView";
import ErrorView from "../../components/Elements/ErrorView";
import Utils from "../../common/Utils";
import TTLProxy from "../../common/TTLAsyncProxy";
import DataList from "../../components/TableListView/DataList";
import {AssignmentRuleMode} from "../../common/Constants";
import _ from 'lodash';
import {DAYS_OF_WEEK_LIST, MONTHS_LIST} from "../../data/calendar/calendar";
import {TractorsEndpoints, USSDEndpoints} from "../../common/ProxyEndpoints";
import {Badge, Button, ButtonToolbar, UncontrolledTooltip} from "reactstrap";
import MDProgress from 'react-md-progress-bar';
import {getDistricts, getWards, listProvinces} from "../../data/locations";
import PropTypes from 'prop-types';
import HTML from '../../common/HtmlHelpers';
import {css} from "glamor";
import TwoLineItemRender from "../../components/Elements/TwoLineItemRender";
import StandardValue from "../../common/StandardValue";
import {PaginatedView} from "../../components/PaginatedView";
import {MultiSelectionDialog} from "../../common/MultiSelectionDialog";

const HourOptions = [
    { label: 'Any' , value: { begin_hour: null, end_hour: null } },
    { label: 'From 6AM' , value: { begin_hour: "6AM", end_hour: null } },
    { label: 'From 8AM' , value: { begin_hour: "8AM", end_hour: null } },
    { label: 'From 12PM' , value: { begin_hour: "12AM", end_hour: null } },
    { label: '6AM - 6PM' , value: { begin_hour: "6AM" , end_hour: "6PM" } },
    { label: '6AM - 4PM' , value: { begin_hour: "6AM", end_hour: "4PM" } },
    { label: '12PM - 6PM' , value: { begin_hour: "12PM", end_hour: "6PM" } },
    { label: '8AM - 12PM' , value: { begin_hour: "8AM", end_hour: "12PM" } },
    { label: '12PM - 2PM' , value: { begin_hour: "12PM", end_hour: "2PM" } },
    { label: '2PM - 6PM' , value: { begin_hour: "2PM", end_hour: "6PM" } },
];

class ItemsListDialog extends React.Component {

    static propTypes = {
        title: PropTypes.string,
        emptyMessage: PropTypes.string,
        searchPlaceholder: PropTypes.string
    };

    static defaultProps = {
        title: "Select an item",
        emptyMessage: "There are no items available to show",
        searchPlaceholder: "Search for an item"
    };

    static itemRowStyle = css({
        cursor: "pointer",
        '&:hover': {
            backgroundColor: '#dedede',
            color: '#000000'
        }
    });

    static selectRowStyle = css({
        cursor: "pointer",
        backgroundColor: '#000000',
        color: '#FFF',
        '&:hover': {
            backgroundColor: '#343434',
            color: '#FFF'
        }
    });

    constructor(props){
        super(props);
        this.state = ItemsListDialog.getInitialState();
    }

    static getInitialState(){

        return {
            title: null,
            searchPlaceholder: null,
            message: null,
            items: [],
            itemsFiltered: [],
            selected: null,
            callback: null
        };

    }

    /**
     * Show item selected dialog
     * @param items
     * @param params
     * @param {String} params.callback
     * @param {String} params.title
     * @param {String} params.searchPlaceholder
     * @param {String} params.message
     */
    show(items,params){

        this.setState({
            ...ItemsListDialog.getInitialState(),
            ...params,
            items,
        }, () => {
            this._dlg.show();
        });

    }

    toggle(){
        this._dlg.toggle();
    }

    render() {

        const { message,  title , emptyMessage , searchPlaceholder , items , selected } = this.state;

        return <SmartDialog ref={r => this._dlg = r}
                            title={title || this.props.title}>

            {message && <p>{message}</p>}

            <PaginatedView noRowsHeight={280}
                           rowHeight={38}
                           data={items || []}
                           height={280}
                           emptyMessage={emptyMessage || this.props.emptyMessage}
                           onItemClick={(item,index) => this.setState({ selected: index })}
                           renderItem={(item,index) => {
                               return <div className={`p-2 ${index === selected ? ItemsListDialog.selectRowStyle : ItemsListDialog.itemRowStyle}`}>{item}</div>
                           }}/>
            <hr/>

            <Button color="green" block disabled={selected === null} onClick={() => {

                if(_.isFunction(this.state.callback)){
                    this.state.callback({ item: items[selected] , index: selected });
                }

                this.toggle();

            }}><i className="fa fa-check"/> Select</Button>
        </SmartDialog>

    }

}

class DistrictConfigurationDialog extends React.Component{

    constructor(props){
        super(props);
        this.state = DistrictConfigurationDialog.getInitialState();
    }

    static getInitialState(){

        return {
            location: null,
            isBusy: false,
            saveCallback: null
        };

    }

    toggle(){
        this._dlg.toggle();
    }

    show(location,callback){

        this.setState({
            ...DistrictConfigurationDialog.getInitialState(),
            location: _.cloneDeep(location),
            saveCallback: callback
        }, () => {
            this._dlg.show()
        });

    }

    render() {

        const { location } = this.state;

        const refreshList = () => {

            this.setState(state => ({
                location: state.location
            }),() => this._list.refresh());

        };


        return <SmartDialog title={`Configure ${process.env.REACT_APP_LOCATION_COMP2}s${location ? ` (${location.province})` :  ''}`}
                            large
                            ref={r => this._dlg = r}>

            <MultiSelectionDialog ref={r => this._multiSelectDlg = r}/>

            <ItemsListDialog ref={r => this._itemsDlg = r}/>

            {location && <React.Fragment>

                <div className="clearfix">

                    <div className="pull-left">
                        Setup availability within <b>{location.province}</b>
                    </div>

                    <div className="pull-right">

                        <ButtonToolbar>

                            <Button onClick={() => {

                                let districts = getDistricts(location.province).map(x => x.value);
                                districts = _.difference(districts, location.districts.map(t => t.district));

                                if(districts.length === 0){
                                    return window.alert(`No more ${process.env.REACT_APP_LOCATION_COMP2.toLowerCase()}s available for selection`);
                                }

                                this._itemsDlg.show(districts, {
                                    title: `Select ${process.env.REACT_APP_LOCATION_COMP2}`,
                                    message: `Please select the ${process.env.REACT_APP_LOCATION_COMP2.toLowerCase()} you wish to add`,
                                    searchPlaceholder: `Search ${process.env.REACT_APP_LOCATION_COMP2.toLowerCase()}s...`,
                                    callback: ({ item , index }) => {

                                        (location.districts || (location.districts = [])).push({
                                            district: item,
                                            wards: []
                                        });

                                        refreshList();
                                    }
                                });

                            }}>
                                <i className="fa fa-plus"/> {`Add ${process.env.REACT_APP_LOCATION_COMP1}`}
                            </Button>

                        </ButtonToolbar>

                    </div>

                </div>

                <DataList listRef={r => this._list = r}
                          itemsPerPage={5}
                          columns={[
                              {
                                  key: "district",
                                  label: `${process.env.REACT_APP_LOCATION_COMP2}`,
                                  render: item => item.district
                              },
                              {
                                  key: "wards",
                                  label: `${process.env.REACT_APP_LOCATION_COMP3}s`,
                                  render: item => {

                                      let content;
                                      if(!_.isNil(item.wards) && item.wards.length > 0){
                                          content = item.wards.join(", ");
                                      }
                                      else{
                                          content = <h6 style={{ display: "inline" }}><Badge pill>Any</Badge></h6>;
                                      }

                                      return <span>{content} <i className="fa fa-edit btn-link" title="Click to edit days" onClick={() => {

                                          this._multiSelectDlg.show(
                                              getWards(location.province,item.district).map(x => ({ ...x, label: x.text})),
                                              (item.wards || []).map(x => ({ value: x,  label : x }) ),
                                              (values) => {
                                                  item.wards = values.map(x => x.value);
                                                  refreshList();
                                              },
                                              `Select ${process.env.REACT_APP_LOCATION_COMP3}`,
                                              `Please select ${process.env.REACT_APP_LOCATION_COMP3.toLowerCase()} you wish to support`);

                                      }}/></span>
                                  }
                              }
                          ]}
                          noRowsMessage={`There are no ${process.env.REACT_APP_LOCATION_COMP2.toLowerCase()} supported in this ${process.env.REACT_APP_LOCATION_COMP1.toLowerCase()}`}
                          data={location.districts || []}/>

                <hr/>

                <div className="clearfix">

                    <div className="pull-right">
                        <Button color="green" onClick={() => {

                            if(_.isFunction(this.state.saveCallback))
                                this.state.saveCallback(this.state.location);


                            this.toggle();

                        }}><i className="fa fa-edit"/> Apply Changes</Button>
                    </div>

                </div>

            </React.Fragment>}


        </SmartDialog>
    }

}

class LocationSelectionDialog extends React.Component {

    constructor(props){
        super(props);
        this.state = LocationSelectionDialog.getInitialState();
    }

    static getInitialState(){

        return {
            rule: null,
            saveCallback: null
        };

    }

    toggle(){
        this._dlg.toggle();
    }

    show(rule,callback){

        this.setState({
            ...LocationSelectionDialog.getInitialState(),
            rule: _.cloneDeep(rule),
            saveCallback: callback
        }, () => {
            this._dlg.show();
        });

    }

    render(){

        const refreshList = () => {

            this.setState(state => ({
                rule: state.rule
            }), () => this._list.refresh());

        };

        return <SmartDialog ref={r => this._dlg = r}
                            title="Configure Location Availability"
                            large>

            <ItemsListDialog ref={r => this._itemsDlg = r}/>

            <DistrictConfigurationDialog ref={r => this._districtDlg = r}/>

            <div className="clearfix">

                <div className="pull-right">

                    <ButtonToolbar>

                        <Button onClick={() => {

                            let provinces = listProvinces().map(x => x.value);
                            provinces = _.difference(provinces, this.state.rule.locations.map(x => x.province));

                            if(provinces.length === 0){
                                return window.alert(`No more ${process.env.REACT_APP_LOCATION_COMP1.toLowerCase()} available for selection`);
                            }

                            this._itemsDlg.show(provinces,{
                                title: `Add ${process.env.REACT_APP_LOCATION_COMP1}`,
                                message: `Please select the ${process.env.REACT_APP_LOCATION_COMP1.toLowerCase()} you wish to add`,
                                searchPlaceholder: `Search ${process.env.REACT_APP_LOCATION_COMP1.toLowerCase()}...`,
                                callback: ({ item , index }) => {

                                    this.state.rule.locations.push({
                                        province: item,
                                        districts: []
                                    });

                                    return refreshList();
                                }

                            });

                        }}><i className="fa fa-plus"/> {`Add ${process.env.REACT_APP_LOCATION_COMP1}`}</Button>

                    </ButtonToolbar>

                </div>

            </div>

            <DataList listRef={r => this._list = r}
                      itemsPerPage={5}
                      data={this.state.rule ? (this.state.rule.locations)  : []}
                      responsive
                      hover={false}
                      noRowsMessage={`There's nothing to show here, click on the add button to add your ${process.env.REACT_APP_LOCATION_COMP1}`}
                      columns={[
                          {
                              key: "province",
                              label: process.env.REACT_APP_LOCATION_COMP1,
                              render: item => {
                                  return item.province;
                              }
                          },
                          {
                              key: "districts",
                              label: `${process.env.REACT_APP_LOCATION_COMP2} (Supported)`,
                              render: item => {

                                  return item.districts.length > 0 ? item.districts.map((x,key) => (<div key={key} className="mb-2">
                                      <b style={{ fontSize: 'medium' }}>{x.district}</b>
                                      <p>Wards: {x.wards.length > 0 ? x.wards.join(", ") : "Any"}</p>
                                  </div>)) : <span>Any</span>;

                              }
                          },
                          {
                              key: "actions",
                              label: "",
                              render: item => {

                                  return <span>

                                      <Button size={"sm"} onClick={() => this._districtDlg.show(item, updated => {

                                          _.assign(item,updated);
                                          return refreshList();

                                      })}><i className="fa fa-edit"/> Configure Districts</Button>

                                      <Button size={"sm"} color="danger" onClick={() => {

                                          if(window.confirm(`Confirm removal of ${process.env.REACT_APP_LOCATION_COMP1} and associated information?`)){
                                              this.state.rule.locations.splice(this.state.rule.locations.indexOf(item),1);
                                              refreshList();
                                          }

                                      }}><i className="fa fa-trash"/> Remove</Button>
                                  </span>

                              }
                          }
                      ]}/>

                      <hr/>

                      <div className="clearfix">

                          <div className="pull-right">

                              <Button color="green" onClick={() => {

                                  if(_.isFunction(this.state.saveCallback)){
                                      this.state.saveCallback(this.state.rule.locations);
                                  }

                                  this.toggle();

                              }}><i className="fa fa-edit"/> Apply Configuration</Button>
                          </div>

                      </div>

        </SmartDialog>

    }

}


function ServiceRender({ id, rule , onClick }) {

    let style;
    let textColor;
    let icon;

    switch(rule.mode){
        case AssignmentRuleMode.Enabled:

            textColor = "#000000";
            icon = "fa fa-check";
            style = {
                backgroundColor: "rgba(0,193,87,0.27)",
                borderColor: "#00c157",
                borderStyle: "solid",
                borderWidth: 1,
            };

            break;
        case AssignmentRuleMode.Disabled:

            textColor = "#404040";
            icon = "fa fa-close";
            style = {
                backgroundColor: "rgba(193,0,31,0.27)",
                borderColor: "#c10c15",
                borderStyle: "solid",
                borderWidth: 1,
            };

            break;
    }

    return <div id={id} style={{
        ...style,
        borderRadius: 4,
        display:"inline-block",
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 4,
        paddingBottom: 4,
        whiteSpace: "nowrap",
        margin: 6,
        cursor: "pointer"
    }} onClick={onClick}><span style={{ cursor: "default" , color : textColor }}>{rule.service.name}</span> <span style={{ marginLeft: 4  }}><i className={icon}/></span>
    </div>

}

export function AssignmentRuleInfo({ rules , onEdit }) {

    return <div style={{ backgroundColor: '#dfdfdf80',
                         padding: rules.length > 0 ? '1em' : '6em',
                         textAlign: 'center' }}>

        <Button style={{ borderRadius: 8,
            boxShadow: "0 2px 1px #b3b3b3",
            paddingLeft: 20 ,
            paddingRight: 20,
            paddingTop: 10,
            paddingBottom: 10,
            fontSize: 11
        }}
                size="sm"
                className="mb-2"
                onClick={onEdit}>
            <i className="fa fa-edit"/> Edit Rules
        </Button>

        {rules.length > 0 ? <React.Fragment>

            <hr/>

            {rules.map((x,id) => (<React.Fragment  key={id}>

                <ServiceRender id={`service-rule-${id}`} rule={x}/>

                <UncontrolledTooltip target={`service-rule-${id}`} placement="top">

                    <div className="text-left">

                        <div><b>Status:</b> {(() => {
                            switch (x.mode) {
                                case AssignmentRuleMode.Enabled:
                                    return "Enabled";
                                case AssignmentRuleMode.Disabled:
                                    return "Disabled";
                            }
                        })()}</div>

                        {x.mode === AssignmentRuleMode.Enabled && <React.Fragment>
                            {!_.isNil(x.min_quantity) && <div><b>Min {x.service.unit_name}s:</b> {x.min_quantity}</div>}
                            {!_.isNil(x.max_quantity) &&  <div><b>Max {x.service.unit_name}s:</b> {x.max_quantity}</div>}
                            {!_.isNil(x.active_hours) && (!_.isNil(x.active_hours.begin_hour) && !_.isNil(x.active_hours.end_hour)) && <div><b>Hours:</b> {(() => {

                                const frame = HourOptions.find(t => t.value.begin_hour === x.active_hours.begin_hour && t.value.end_hour === x.active_hours.end_hour);
                                if(frame){
                                    return frame.label;
                                }

                                return `${x.active_hours.begin_hour} - ${x.active_hours.end_hour}`;

                            })()}</div>}
                        </React.Fragment>}

                    </div>
                </UncontrolledTooltip>

            </React.Fragment> ))}
        </React.Fragment> : <p style={{ color: "#404040"}}>There are no rules defined yet</p>}
    </div>

}

/**
 * Provides editing functionality for tractor assignment
 */
class AssignmentRulesConfigDialog extends React.Component{

    static propTypes = {
        fetchAssignmentRules: PropTypes.func,
        updateAssignmentRules: PropTypes.func,
        afterUpdate: PropTypes.func
    };

    static defaultProps = {

        fetchAssignmentRules: async tractor => {

            //
            if(!_.isNil(tractor.assignment_rules))
                return tractor.assignment_rules;

            const proxy = TTLProxy.getInstance();
            return (await proxy.processRequest(TractorsEndpoints.getAssignmentRules(tractor.id))).getPayload();
        },

        updateAssignmentRules: async (tractor,rules) => {

            const proxy = TTLProxy.getInstance();
            const queryRules = rules.map(({ service ,...rule}) => (rule));
            if((await proxy.processRequest(TractorsEndpoints.updateAssignmentRules(tractor.id,queryRules))).ok){
                HTML.toastSuccess('Assignment rules updated');
                return true;
            }

        }

    };

    constructor(props){
        super(props);
        this.state = AssignmentRulesConfigDialog.getInitialState();
        this.onSubmit = this.onSubmit.bind(this);
        this.proxy = TTLProxy.getInstance();
    }

    static getInitialState(){

        return {
            tractor: null,
            isBusy: false,
            services: [],
            rules: [],
            error: null,
            isSaving: false
        };

    }

    show(tractor){

        this.setState({
            ...AssignmentRulesConfigDialog.getInitialState(),
            tractor
        }, () => {

            //  load state
            this.loadState(tractor);

            //  show dialog
            this._dlg.show();

        });

    }

    async loadState(tractor){

        this.setState({ isBusy: true });

        try{

            const response = await this.proxy.processRequest(USSDEndpoints.getUSSDServices());
            const assignment_rules = await this.props.fetchAssignmentRules(tractor);
            const services = response.getPayload();

            services.forEach(item => {

                let rule = assignment_rules.find(x => x.service.id === item.id);
                if(!rule){
                    rule = {
                        mode: AssignmentRuleMode.Enabled,
                        service_id: item.id,
                        service: _.omit(item,['rule']),
                        min_quantity: null,
                        max_quantity: null,
                        locations: [],
                        days_of_week: null,
                        months_of_year: null,
                        active_hours: {
                            begin_hour: null,
                            end_hour: null
                        }
                    };
                }

                item.rule = rule;
            });

            this.setState({
                services: _.cloneDeep(services)
            });

        }
        catch (e) {

            this.setState({
                error: Utils.getResponseError(e)
            });

        }
        finally {
            this.setState({ isBusy: false });
        }

    }

    async onSubmit(){

        this.setState({ isSaving: true });

        try{

            if(await this.props.updateAssignmentRules(this.state.tractor,this.state.services.map(x => {
                const { date_created , last_updated , ...rule } = x.rule;
                return rule;
            }))){


                //
                if(_.isFunction(this.props.afterUpdate)){
                    this.props.afterUpdate();
                }

                //
                this._dlg.hide();
            }

        }
        catch (e) {
            HTML.toastError(Utils.getResponseError(e));
        }
        finally {
            this.setState({ isSaving: false });
        }
    }

    render(){

        const { services , isBusy , error } = this.state;

        const refreshList = () => {

            this.setState(state => ({
                services: state.services
            }), () => this._list.refresh());

        };

        const renderTractorInfo = () => {

            const { tractor } = this.state;
            return <TwoLineItemRender media={tractor.media}
                                      line1Value={tractor.name}
                                      line2Prefix={"Operator/Driver"}
                                      line2Value={<StandardValue value={tractor.operator}>
                                          {tractor.operator ? tractor.operator.name : null} ({tractor.operator ? tractor.operator.phone : null})
                                      </StandardValue>}/>

        };

        return <SmartDialog ref={r => this._dlg = r}
                            title={"Configure Assignment Rules"}
                            classNames={"fullscreen-modal-dialog"}
                            contentClassName={"fullscreen-modal-content-w100"}
                            large>

            <LoadingView message="Preparing rules, please hold on..." isBusy={isBusy}>

                <ErrorView error={error} retryCallback={() => this.loadState(this.state.tractor)}>

                    <MultiSelectionDialog ref={r => this._selectionDlg = r}/>

                    <LocationSelectionDialog ref={r => this._locationSelectDlg = r}/>

                    {this.state.tractor && renderTractorInfo()}

                    <DataList listRef={r => this._list = r}
                              noRowsMessage={"No rules available"}
                              hover={false}
                              columns={[
                                  {
                                      key: "mode",
                                      label: "",
                                      render: item => {

                                          const rule = item.rule;
                                          return <input type="checkbox" checked={rule.mode === AssignmentRuleMode.Enabled} onChange={evt => {

                                              const checked = evt.target.checked;
                                              item.rule.mode = checked ? AssignmentRuleMode.Enabled : AssignmentRuleMode.Disabled;
                                              refreshList();

                                          }}/>;

                                      }
                                  },
                                  {
                                      key: "service",
                                      label: "Service",
                                      render: item => {
                                          return item.name;
                                      }
                                  },
                                  {
                                      key: "min_quantity",
                                      label: "Min Quantity",
                                      render: item => {

                                          const rule = item.rule;
                                          return <input type="number"
                                                        value={_.isNil(rule.min_quantity) ? '' : rule.min_quantity}
                                                        min={0}
                                                        max={999}
                                                        onBlur={() => {

                                                            let val = Math.min( Math.max(rule.min_quantity, 0) , rule.max_quantity || 999 );
                                                            if(val !== rule.min_quantity && (val !== 0 && rule.min_quantity !== null)){
                                                                rule.min_quantity = val;
                                                                return refreshList();
                                                            }

                                                        }}
                                                        className="form-control form-input-select" onChange={evt => {

                                              if(evt.target.value === ''){
                                                  rule.min_quantity = null;
                                              }
                                              else{
                                                  rule.min_quantity = Number(evt.target.value);
                                              }

                                              refreshList();

                                          }}/>
                                      }
                                  },
                                  {
                                      key: "max_quantity",
                                      label: "Max Quantity",
                                      render: item => {

                                          const rule = item.rule;
                                          return <input type="number"
                                                        value={_.isNil(rule.max_quantity) ? '' : rule.max_quantity}
                                                        min={rule.min_quantity || 0}
                                                        max={999}
                                                        onBlur={() => {

                                                            let val = Math.min( Math.max(rule.max_quantity, rule.min_quantity || 0) , 999 );
                                                            if(val !== rule.max_quantity && (val !== 0 && rule.max_quantity !== null)){
                                                                rule.max_quantity = val;
                                                                return refreshList();
                                                            }

                                                        }}
                                                        className="form-control form-input-select" onChange={evt => {

                                              if(evt.target.value === ''){
                                                  rule.max_quantity = null;
                                              }
                                              else{
                                                  rule.max_quantity = Number(evt.target.value);
                                              }

                                              refreshList();

                                          }}/>
                                      }
                                  },
                                  {
                                      key: "locations",
                                      label: "Location Availability",
                                      render: item => {

                                          let content;
                                          const rule = item.rule;
                                          const locations  = rule.locations;
                                          if(locations.length > 0){
                                              content = locations.map(l => l.province).join(', ');
                                          }
                                          else{
                                              content = <h6 style={{ display: "inline" }}><Badge pill>Any</Badge></h6>;
                                          }

                                          return <span>{content} <i className="fa fa-edit btn-link" title="Click to edit locations" onClick={() => {

                                              this._locationSelectDlg.show(rule, locations => {
                                                  rule.locations = locations;
                                                  console.log(locations);
                                                  return refreshList();
                                              });

                                          }}/></span>
                                      }
                                  },
                                  {
                                      key: "activeMonths",
                                      label: "Active Month",
                                      render: item => {

                                          let content;
                                          const rule = item.rule;
                                          if(!_.isNil(rule.months_of_year) && rule.months_of_year.length > 0){
                                              content = rule.months_of_year.map(x => MONTHS_LIST[Number(x) - 1].substr(0,3) ).join(", ");
                                          }
                                          else{
                                              content = <h6 style={{ display: "inline" }}><Badge pill>Every Month</Badge></h6>;
                                          }

                                          return <span>{content} <i className="fa fa-edit btn-link" title="Click to edit months" onClick={() =>

                                              this._selectionDlg.show(

                                                  MONTHS_LIST.map((x,index) => ({ label: x , value: (index + 1) })),

                                                  (rule.months_of_year || []).map(x => {
                                                      let val = MONTHS_LIST[Number(x) - 1];
                                                      return { label : val , value : Number(x) }
                                                  }),

                                                  (values) => {

                                                      rule.months_of_year = values.map(x => x.value);
                                                      refreshList();

                                                  },
                                                  "Active Months",
                                                  "Please select months tractor is available for assignment")

                                          }/></span>
                                      }
                                  },
                                  {
                                      key: "activeDays",
                                      label: "Active Days",
                                      render: item => {

                                          let content;
                                          const rule = item.rule;
                                          if(!_.isNil(rule.days_of_week) && rule.days_of_week.length > 0){
                                              content = rule.days_of_week.map(x => DAYS_OF_WEEK_LIST[Number(x) - 1].substr(0,3) ).join(", ");
                                          }
                                          else{
                                              content = <h6 style={{ display: "inline" }}><Badge pill>Every Day</Badge></h6>;
                                          }

                                          return <span>{content} <i className="fa fa-edit btn-link" title="Click to edit days" onClick={() => {
                                              this._selectionDlg.show(
                                                  DAYS_OF_WEEK_LIST.map((x,index) => ({ label: x , value: (index + 1) })),

                                                  (rule.days_of_week || []).map(x => {
                                                      let val = DAYS_OF_WEEK_LIST[Number(x) - 1];
                                                      return { label : val , value : Number(x) }
                                                  }),

                                                  (values) => {

                                                      rule.days_of_week = values.map(x => x.value);
                                                      refreshList();

                                                  },
                                                  "Active Days",
                                                  "Please select days of week tractor is available for assignment"
                                              )
                                          }}/></span>
                                      }
                                  },
                                  {
                                      key: "hourRange",
                                      label: "Active Hours",
                                      render: item => {

                                          const rule = item.rule;
                                          let value = 0;
                                          if(rule.active_hours){

                                              const frame = HourOptions.findIndex(x => x.value.begin_hour === rule.active_hours.begin_hour && x.value.end_hour === rule.active_hours.end_hour);
                                              if(frame >= 0){
                                                  value = frame;
                                              }

                                          }

                                          return <select className="form-control form-input-select" value={value} onChange={evt => {
                                              rule.active_hours = HourOptions[Number(evt.target.value)].value;
                                              return refreshList();
                                          }}>
                                              {HourOptions.map((h,index) => (<option key={index} value={index}>{h.label}</option>))}
                                          </select>
                                      }
                                  }

                              ]}
                              itemsPerPage={10}
                              responsive
                              data={services || []} />

                    {this.state.isSaving && <MDProgress overlay show/>}

                    <hr/>

                    <div className="clearfix">

                        <div className={"pull-right"}>
                            <Button color="green" onClick={this.onSubmit}><i className="fa fa-check"/> Save Changes</Button>
                        </div>

                    </div>

                </ErrorView>

            </LoadingView>

        </SmartDialog>

    }

}

export default AssignmentRulesConfigDialog;



// WEBPACK FOOTER //
// ./src/views/Tractors/AssignmentRulesConfigDialog.js